import {createSelector} from 'reselect'
import R from 'ramda'

const estateListIdsIndex = state => state.estateListIdsIndex
const estateMap = state => state.estateMap
const matchingAndNonMatchingEstatesOnMap = createSelector(
    [
      estateListIdsIndex,
      estateMap
    ], 
    (estateListIdsIndex, estateMap) => R.partition(estate => estateListIdsIndex[estate.id], estateMap))
export default matchingAndNonMatchingEstatesOnMap



/** WEBPACK FOOTER **
 ** ./app/selectors/partionEstateMapByMatch.js
 **/